import { useState } from 'react'
import NumberFormat from 'react-number-format'

import { Button, Card, CryptoIcon, Input } from '../../components'
import { EtherscanAddress } from '../../components/etherscan-address'
import { Modal } from '../../components/modal'
import { PlatformStats } from '../../components/platform-stats'
import { PoolsTable } from '../../components/pools-table'
import { SimpleModal } from '../../components/simple-modal'

export function PoolDashboard() {
    const [openDeposit, setOpenDeposit] = useState(false)
    const [openWithdraw, setOpenWithdraw] = useState(false)
    const [depositing, setDepositing] = useState(false)

    const [depositValue, setDeposit] = useState('')
    const [withdrawValue, setWithdraw] = useState('')
    const [error, setError] = useState<null | string>(null)
    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const enfasisClasses = ' text-black '
    const ethereum = (window as any).ethereum

    const deposit = async (e: any) => {
        setDepositing(true)
        setError(null)
        e.preventDefault()
        const transactionParameters = {
            nonce: '0x00',
            gasPrice: '0x09184e72a000',
            gas: '0x2710',
            to: '0x0000000000000000000000000000000000000000',
            from: ethereum.selectedAddress,
            value: '123',
            data: '0x7f7465737432000000000000000000000000000000000000000000000000000000600057',
            chainId: '0x3',
        }

        try {
            await ethereum.request({
                method: 'eth_sendTransaction',
                params: [transactionParameters],
            })
        } catch (e) {
            //@ts-ignore
            setError(e.message)
        }

        setDepositing(false)
    }
    return (
        <>
            <div
                className='grid h-full gap-4 py-4 gird-cols-6'
                style={{ gridTemplateRows: '1fr 1fr' }}>
                <div className='col-span-4 row-span-1 xl:col-span-3'>
                    <Card className='w-full h-full py-8 '>
                        <h3>🌽 Masa USDC A Pool</h3>
                        <PoolsTable
                            headers={[
                                'Asset',
                                'Masa NFT USDC',
                                'Pool Value',
                                'Utilization',
                                'Interest APY',
                                'LP Token Price',
                                'Pool Insurance Fund',
                            ]}
                            items={
                                <>
                                    <tr
                                        className='border-b border-solid border-gray border-opacity-10 group'
                                        data-test-id={`transaction-item`}>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-row justify-center w-full p-1'>
                                                <CryptoIcon name='USDC' />
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-row justify-center font-semibold truncate text-linkYellow'>
                                                <EtherscanAddress
                                                    address={'0x7899...67h7'}
                                                />
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p className='font-normal text-black'>
                                                    $134,608.00
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p>
                                                    <span className='font-normal text-black'>
                                                        35%
                                                    </span>{' '}
                                                    liquid
                                                </p>
                                                <p>
                                                    <span className='font-normal text-black'>
                                                        65%
                                                    </span>{' '}
                                                    liquid
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p>
                                                    <span className='font-normal text-black'>
                                                        17%
                                                    </span>
                                                    liquid
                                                </p>
                                                <p>
                                                    <span className='font-normal text-black'>
                                                        6%
                                                    </span>
                                                    liquid
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p className='font-normal text-black'>
                                                    $1.15
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-row items-start justify-center h-full break-words'>
                                                <p className='font-normal text-black'>
                                                    $13,542.00
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                        />

                        <div className='mt-4 border-b border-gray2'>
                            <h3>Your pool balances</h3>
                            <div className='flex flex-row w-full mb-4 border-b border-gray2'>
                                <p className='w-1/2 text-black'>
                                    USDC Balance: $150,000.89
                                </p>
                                <p className='w-1/2 text-black'>
                                    mnUSDC Balance: 150,000.89
                                </p>
                            </div>

                            <div className='grid grid-cols-2 grid-rows-1 gap-8'>
                                <div className='flex flex-col items-center'>
                                    <div className='flex flex-row justify-between w-full mb-4 text-sm font-light '>
                                        <p className='text-gray8'>
                                            Deposit USDC
                                        </p>
                                        <p className='text-gray8'>
                                            Wallet balance: 0 USDC
                                        </p>
                                    </div>
                                    <div className='relative flex flex-row items-center w-full'>
                                        <Input
                                            placeholder='0.00'
                                            value={depositValue}
                                            onChange={e => {
                                                setDeposit(e.target.value)
                                            }}
                                        />
                                        <div className='absolute flex flex-row gap-x-4 right-6'>
                                            <p className='mb-0 '>USDC</p>
                                            <p className='mb-0 text-black'>
                                                Max
                                            </p>
                                        </div>
                                    </div>
                                    <Button
                                        disabled={!depositValue}
                                        className='w-full py-4 mt-4'
                                        onClick={() => {
                                            setError(null)
                                            setOpenDeposit(true)
                                        }}>
                                        Deposit to pool
                                    </Button>
                                </div>
                                <div className='flex flex-col items-center'>
                                    <div className='flex flex-row justify-between w-full mb-4 text-sm font-light '>
                                        <p className='text-gray8'>
                                            Deposit mnUSDC
                                        </p>
                                        <p className='text-gray8'>
                                            Wallet balance: 0 mnUSDC
                                        </p>
                                    </div>
                                    <div className='relative flex flex-row items-center w-full'>
                                        <Input
                                            placeholder='Enter amount'
                                            value={withdrawValue}
                                            onChange={e => {
                                                setWithdraw(e.target.value)
                                            }}
                                        />
                                        <div className='absolute flex flex-row gap-x-4 right-6'>
                                            <p className='mb-0 '>mnUSDC</p>
                                            <p className='mb-0 text-black'>
                                                Max
                                            </p>
                                        </div>
                                    </div>
                                    <Button
                                        className='w-full py-4 mt-4'
                                        onClick={() => setOpenWithdraw(true)}
                                        disabled={!withdrawValue}>
                                        Withdraw to pool
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>

                <div className='col-span-4 row-span-1 xl:row-span-2 xl:col-start-4 xl:row-start-1 xl:col-span-1 '>
                    <Card>
                        <PlatformStats />
                    </Card>
                </div>
            </div>
            <Modal show={openDeposit} onClose={() => setOpenDeposit(false)}>
                <SimpleModal
                    title={
                        depositing
                            ? 'Waiting for confirmation'
                            : 'Deposit to pool'
                    }
                    onClose={() => setOpenDeposit(false)}
                    hideFooter={depositing}
                    buttons={[
                        {
                            label: error ? 'Try again' : 'Deposit',
                            onClick: deposit,
                        },
                    ]}>
                    {!error ? (
                        <p className='font-light text-gray8'>
                            {!depositing ? (
                                <>
                                    Your are about to deposit{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    USDC to the Masa USDC A Pool
                                </>
                            ) : (
                                <>
                                    You are depositing{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    USDC to the Masa USDC A Pool. Please confirm
                                    this transaction in your wallet
                                </>
                            )}
                        </p>
                    ) : (
                        <p className='font-light text-danger'>{error}</p>
                    )}
                </SimpleModal>
            </Modal>
            <Modal show={openWithdraw} onClose={() => setOpenWithdraw(false)}>
                <SimpleModal
                    onClose={() => setOpenWithdraw(false)}
                    title='Withdraw from pool'
                    buttons={[
                        {
                            label: error ? 'Try again' : 'Withdraw',
                            onClick: deposit,
                        },
                    ]}>
                    {!error ? (
                        <p className='font-light text-gray8'>
                            Your are about to withdraw
                            <NumberFormat
                                value={withdrawValue}
                                fixedDecimalScale={true}
                                decimalScale={2}
                                thousandSeparator={true}
                                displayType={'text'}
                                className='inline'
                            />{' '}
                            USDC to the Masa USDC A Pool
                        </p>
                    ) : (
                        <p className='font-light text-danger'>{error}</p>
                    )}
                </SimpleModal>
            </Modal>
        </>
    )
}
